import { useMemo } from "react";

import { useHandbookSegments } from "pages/HandBook/hooks/useHandbookSegments";
import { IHandBookTemplateExpenditure } from "pages/HandBook/model/types";
import { getResourceSymbol } from "pages/HandBook/utils/resourceNames";
import { findSegmentsById } from "pages/HandBook/utils/segments";

import { ICommonColumn } from "../templates/HandBooksTemplates";

import { LOCALIZATION_CONFIG } from "constants/localization";

import { transformDigitToFinancial } from "utils/formatters/transformDigitToFinancial";

import styles from "./HandBooksTemplateExpenditureRow.module.scss";

interface IuseHandbookTemplatesExpendituresColumns {
  isEditing: boolean;
}

export const useHandbookTemplatesExpendituresColumns = ({ isEditing }: IuseHandbookTemplatesExpendituresColumns) => {
  const segments = useHandbookSegments();

  const columns: ICommonColumn<IHandBookTemplateExpenditure>[] = useMemo(
    () =>
      (
        [
          {
            header: { title: "Наименование", filterName: "name" },
            render: (item) => (
              <span className={item.manual_expenditure.type !== "work" ? styles.materialNameCol : ""}>
                {item.manual_expenditure.type !== "work" ? (
                  <span className={styles.materialSymbol}>{getResourceSymbol(item.manual_expenditure.type)}</span>
                ) : null}
                {item.manual_expenditure?.name}
              </span>
            ),
          },
          !isEditing && {
            header: { title: "Атрибут 1" },
            render: (item) => {
              if (!item.segment) return null;
              const { parentSegment } = findSegmentsById(segments, item.segment);
              return <span>{parentSegment?.name}</span>;
            },
          },
          !isEditing && {
            header: { title: "Атрибут 2" },
            render: (item) => {
              if (!item.segment) return null;
              const { segment } = findSegmentsById(segments, item.segment);
              return <span>{segment?.name}</span>;
            },
          },
          { header: { title: "Ед. изм." }, render: (item) => item.manual_expenditure?.measure, isCentered: true },
          {
            header: { title: "Кол-во" },
            render: (item) => item.count ?? item.manual_expenditure?.count,
            isCentered: true,
          },
          {
            header: { title: `Цена ${LOCALIZATION_CONFIG.currency}` },
            render: (item) => transformDigitToFinancial(item.price ?? item.manual_expenditure?.price),
            isRighted: true,
          },
          !isEditing && {
            header: { title: `Стоимость ${LOCALIZATION_CONFIG.currency}` },
            render: (item) =>
              transformDigitToFinancial(
                (Number(item.price ?? item.manual_expenditure?.price) || 0) *
                  (Number(item.count ?? item.manual_expenditure?.count) || 0)
              ),
            isRighted: true,
          },
        ] as ICommonColumn<IHandBookTemplateExpenditure>[]
      ).filter((x) => x),
    [isEditing, segments]
  );

  const colPercents = !isEditing ? [46, 10, 10, 7, 7, 7, 10] : [76, 7, 7, 7];
  const formColPercents = [3, 73, 7, 7, 7];
  return { columns, colPercents, formColPercents };
};
